import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { canPlay } from 'containers/Player/utils/PlayRules';
import { isFutureEvent } from './../../../utils';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';

export const useVisiblePlayButton = (
  contentId,
  contentType,
  eventBeginTime,
) => {
  const [isVisiblePlayButton, setIsVisiblePlayButton] = useState(false);
  const { contentsPlayButtonList, popularPlayButtonList } = useSelector(
    state => state.search.MCSInfo,
  );
  const infinite = useSelector(state => state.linealChannel?.data);
  const claroAdsKey = useSelector(state => getClaroAdsKey(state));

  const getDatacontentsPlayButtonList = () => {
    try {
      return _.isEmpty(Object?.keys(contentsPlayButtonList));
    } catch (error) {
      console.warn(error);
      return false;
    }
  };

  const setVisbleButtonWhithoutClaroAds = () => {
    if (getDatacontentsPlayButtonList()) {
      popularPlayButtonList?.hasOwnProperty(contentId) &&
        popularPlayButtonList?.[contentId]?.visible === true &&
        setIsVisiblePlayButton(true);
    } else {
      contentsPlayButtonList?.hasOwnProperty(contentId) &&
        contentsPlayButtonList?.[contentId]?.visible === true &&
        setIsVisiblePlayButton(true);
    }
  };

  const setVisibleButtonWithClaroAds = () => {
    if (getDatacontentsPlayButtonList()) {
      popularPlayButtonList?.hasOwnProperty(contentId) &&
        (popularPlayButtonList?.[contentId]?.visible === true ||
          popularPlayButtonList?.[contentId]?.visibleFremium === true) &&
        setIsVisiblePlayButton(true);
    } else {
      contentsPlayButtonList?.hasOwnProperty(contentId) &&
        (contentsPlayButtonList?.[contentId]?.visible === true ||
          contentsPlayButtonList?.[contentId]?.visibleFremium === true) &&
        setIsVisiblePlayButton(true);
    }
  };

  useEffect(() => {
    //Pinta el boton de play en live, si esta contratado y si no es evento futuro
    if (contentType === 'L' || contentType === 'E') {
      canPlay(contentId, infinite) &&
        !isFutureEvent(eventBeginTime) &&
        setIsVisiblePlayButton(true);
      return;
    }
  }, []);

  useEffect(
    () => {
      if (contentType === 'L' || contentType === 'E') return;

      //Pinta el boton de play en contenidos VOD y series
      if (claroAdsKey) return setVisibleButtonWithClaroAds();
      setVisbleButtonWhithoutClaroAds();
    },
    [popularPlayButtonList, contentsPlayButtonList],
  );
  return { isVisiblePlayButton };
};
